import { useEffect, useState } from "react";
import FullListElements from "../../components/FullListElements/FullListElements";
import { Team, TeamWithCount } from "../../services/shirts/types";
import { ItemListElement } from "../../components/SortedItemsList/SortedItemsList";
import defaultAvatarImg from "../../img/defaultProfile.jpg";
import TopService from "../../services/topService";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const TopTeams = () => {
  const title = "All clubs";

  const [teams, setTeams] = useState<Array<TeamWithCount> | undefined>(
    undefined
  );
  const [teamsProcessed, setTeamsProcessed] = useState<
    Array<ItemListElement> | undefined
  >(undefined);
  const [lastPage, setLastPage] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);

  const { getTopTeams } = TopService();

  const navigate = useNavigate();

  const search = (page: number) => {
    getTopTeams(10, page).then((result) => {
      if (result) {
        setTeams(result.data as Array<TeamWithCount>);
        setLastPage(result.lastPage);
        setTotalElements(result.total);
      }
    });
  };

  const renderValue = (value: number) => {
    return String(value) + " shirts";
  };

  const goToResults = (id: string | number) => {
    navigate("/shirts-collections/team/" + id);
  };

  useEffect(() => {
    getTopTeams(10, 1).then((result) => {
      if (result) {
        setTeams(result.data as Array<TeamWithCount>);
        setLastPage(result.lastPage);
        setTotalElements(result.total);
      }
    });
  }, []);

  useEffect(() => {
    if (teams) {
      let teamItems: Array<ItemListElement> = [];
      teams.forEach((team) => {
        teamItems.push({
          id: team.id,
          name: team.name,
          value: team.appearances,
          logo: team.logo,
        });
      });
      setTeamsProcessed(teamItems);
    }
  }, [teams]);

  return teamsProcessed ? (
    <FullListElements
      elements={teamsProcessed}
      title={title}
      defaultAvatarImg={defaultAvatarImg}
      searchByPage={search}
      renderValue={renderValue}
      lastPage={lastPage}
      totalElements={totalElements}
      handleOnClick={goToResults}
      itemsPerPage={itemsPerPage}
      setItemsPerPage={setItemsPerPage}
    />
  ) : (
    <CircularProgress />
  );
};

export default TopTeams;
